import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BasicModal } from '../../common/modals/BasicModal';

class FinancialStoriesModal extends Component {
  constructor(props) {
    super(props);

    this.confirmCancel = this.confirmCancel.bind(this);

    this.state = { isConfirming: this.props.confirmCancel };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isConfirming: nextProps.confirmCancel,
    });
  }

  confirmCancel(cancelApplication) {
    this.setState({
      isConfirming: false,
    });

    if (cancelApplication) {
      this.props.onClickDeleteTag();
    } else {
      this.props.onPopupCancelClick && this.props.onPopupCancelClick();
    }
  }

  render() {
    return (
      <div>
        {this.state.isConfirming && (
          <BasicModal>
            <div className="modal_content">
              <h3>{this.props.header}</h3>
              <p>{this.props.content}</p>
            </div>
            <div className="modal_footer">
              {this.props.cancelButton && (
                <button
                  onClick={() => {
                    this.confirmCancel(false);
                  }}
                  className="btn btn-confirm"
                  data-anchor="confirm-cancel-button"
                >
                  {' '}
                  {this.props.cancelText}
                </button>
              )}
              {this.props.yesButton && (
                <button
                  onClick={() => {
                    this.confirmCancel(true);
                  }}
                  className="btn btn-confirm"
                  data-anchor="confirm-cancel-button"
                >
                  {' '}
                  <b>
                    <strong>{this.props.yesText}</strong>
                  </b>
                </button>
              )}
            </div>
          </BasicModal>
        )}
      </div>
    );
  }
}

FinancialStoriesModal.propTypes = {
  confirmCancel: PropTypes.bool,
  onClickDeleteTag: PropTypes.func,
  header: PropTypes.string,
  content: PropTypes.string,
  cancelButton: PropTypes.bool,
  cancelText: PropTypes.string,
  yesButton: PropTypes.bool,
  yesText: PropTypes.string,
  onPopupCancelClick: PropTypes.func,
};

export default FinancialStoriesModal;
